export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9866.fa822264.jpg";